module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/license-checked-w-thick-47aadeacb0ca7787085fbefb6db66195.svg";